import { gql } from 'graphql-request';

export const getShopifyCollection = (handle) => {
    return gql`{
  collectionByHandle(handle: "${handle}") {
    title
    descriptionHtml
  }}
`;
};
